import { HisValueGroup } from './his-value-group';
import { HisBaseGlobalsService } from './../../core/service/base/his-base-globals.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { HisDynamicFieldConfig, searchFieldConfig, HisDynamicFieldType } from './formfield';
import * as _ from 'lodash';

export abstract class HisDynamicFieldBase<T> {
    value: T;
    id: number;
    name: string;
    required: boolean;
    order: number;
    controlType: HisDynamicFieldType;
    captionShort: string;
    captionLong: string;
    defaultValue: any;
    ddKey: string;
    disabled: boolean;

    formControl: UntypedFormControl;
    formGroup: UntypedFormGroup;
    valueGroup: HisValueGroup;

    constructor(
        formGroup: UntypedFormGroup,
        options: HisDynamicFieldConfig,
        valueGroup: HisValueGroup,
        private hisBaseGlobalsService: HisBaseGlobalsService ) {
        this.value = this.getValue( options.defaultValue );
        this.name = options.name;
        this.required = !!options.required;
        this.ddKey = options.ddKey;
        this.controlType = options.controlType;
        this.formGroup = formGroup;
        this.valueGroup = valueGroup;
        this.disabled = !!options.disabled;
    }

    initFormControl( value: any ) {
        this.defaultValue = _.cloneDeep( value );
        if ( this.formGroup ) {
            if ( this.required ) {
                if ( this.ddKey ) {
                    this.formControl = new UntypedFormControl( value );
                } else {
                    this.formControl = new UntypedFormControl( value, { validators: [Validators.required] } );
                }
            } else {
                this.formControl = new UntypedFormControl( value );
            }
            if ( this.disabled ) {
                this.formControl.disable();
            }
            this.registerSelfWithGroups();
        }
    }

    getValue( value: any ): any {
        if ( !!value || value === 0 || value === false ) {
            return value;
        }
        return '';
    }

    private registerSelfWithGroups() {
        this.formGroup.registerControl( this.name, this.formControl );
        this.valueGroup.registerDynamicField( this, this.formControl.valueChanges );
    }

    searchFieldConfig( fieldConfigTree: HisDynamicFieldConfig ): HisDynamicFieldConfig {
        let searchCriterion = ( config: HisDynamicFieldConfig ): boolean => config.name === this.name;
        return searchFieldConfig( fieldConfigTree, searchCriterion );
    }

    reset() {
        if ( this.formGroup ) {
            this.formControl.reset( this.defaultValue );
        }
    }

    // update the configuration of an already instantiated dynamic component;
    // i.e. alter the available items of a multiselect
    // 'entireFormConfig' may be a hierarchical structure with multiple field configurations,
    // so a field component may have to/should search the structure for the 'HisDynamicFieldConig'
    // object, that matches it's name
    abstract updateConfiguration( entireFormConfig: HisDynamicFieldConfig ): void;

    // returns an object of the form data suitable for submit
    abstract getControlValue(): any;

}
